module.exports = __webpack_public_path__ + "media/assets/images/icon_met-d093c1b3de9e3ba48113eaeeeef90b0f.png";